export default __webpack_public_path__ + "static/media/smart-contract.e2ee57de.webp";